import initalSearch from "PFCore/initial_state/search";
import { searchDispatch, searchReducer } from "PFReducers/search_reducer/search_reducer";
import { PropsWithChildren, useCallback, useReducer } from "react";

import { SearchDispatchContext, SearchStoreContext } from "./search_context";

const initialState = () => ({ search: initalSearch({}) });

// searchReducer returns `{}` for action types it doesn't handle, expecting the caller to merge
// that into the previous state rather than replace it outright.
const reducer = (state, action) => ({ ...state, ...(searchReducer(state, action) || {}) });

export const SearchContextProvider = ({ children }: PropsWithChildren) => {
  const [store, reducerDispatch] = useReducer(reducer, initialState());
  const dispatch = useCallback((action) => {
    searchDispatch(reducerDispatch, action);
    return reducerDispatch(action);
  }, []);

  return (
    <SearchStoreContext.Provider value={store}>
      <SearchDispatchContext.Provider value={dispatch}>{children}</SearchDispatchContext.Provider>
    </SearchStoreContext.Provider>
  );
};
